import { gql } from '@apollo/client';

export const getArrepentimiento = gql`
query ArrepentimientoApi{
    arrepentimiento(id:$idArrepentimiento, idSec:$sec)  
    @rest(type: "ArrepentimientoVuelta", path: "/api/gateway/formularios/Arrepentido/{args.id}/{args.idSec}"){
       data
       resultado
       error
       stacktrace
    }
}
`   